/* © CNES */
import moment from 'moment';
import { Button } from 'primereact/button';
import { Image } from 'primereact/image';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Logos from '../assets/images/logosToolbarLightGeodes.png';
import './PageMaintenance.scss';

/**
 * PageMaintenance Page displayed when application is in maintenance.
 * @returns Element.
 */
export const PageMaintenance = () => {
  const navigate = useNavigate();
  const [milliSeconds, setMilliSeconds] = useState(600000);

  useEffect(() => {
    if (milliSeconds > 0) {
      setTimeout(() => setMilliSeconds(milliSeconds - 1000), 1000);
    } else if (window.location.href.includes('maintenance')) {
      navigate('/');
    } else {
      window.location.reload();
    }
  });

  return (
    <div className="MaintenanceContainer">
      <div className="HeaderContainer">
        <Image aria-label="Logos" src={Logos} alt="app_logos" width="360" />
      </div>

      <div className="IllustrationContainer">
        <img
          alt="Maintenance page illustration"
          src={require('../assets/images/pageMaintenance.png')}
        />
      </div>

      <div className="TextContainer">
        <h1 className="TextTitle">EARTH NOT FOUND</h1>
        <h3 className="TextDescription">
          The site is down for maintenance but we'll be back soon!
        </h3>
      </div>

      <div className="ButtonContainer">
        <Button
          label="Return to GEODES"
          className="MaintenanceButton"
          onClick={() => {
            if (window.location.href.includes('maintenance')) {
              navigate('/');
            } else {
              window.location.reload();
            }
          }}
        ></Button>
      </div>

      <div className="TextContainer">
        <span className="TextDescription">
          Trying to reconnect in{' '}
          {moment(milliSeconds).format('mm [min] ss [sec]')}
        </span>
      </div>
    </div>
  );
};
